import { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function renderIf(condition: any, renderFn: () => ReactNode) {
  if (condition) {
    return renderFn();
  }

  return <></>;
}

export { renderIf };
